import {
    checkValuesArguments,
    getAsyncBoolResultHandler,
    getAsyncErrorResultHandler,
    getAsyncResultHandler,
    getAsyncReturnedResultHandler,
    getAsyncTextResultHandler,
    getOperands,
    getSum,
    wrapDecimalOperand,
} from "../../Helpers/AutocalcCommonFunctions";

export const injectableHelpers = {
    autocalcCommonFunctions: {
        getAsyncResultHandler: getAsyncResultHandler,
        getAsyncTextResultHandler: getAsyncTextResultHandler,
        getAsyncBoolResultHandler: getAsyncBoolResultHandler,
        wrapDecimalOperand: wrapDecimalOperand,
        getSum: getSum,
        checkValuesArguments: checkValuesArguments,
        getAsyncErrorResultHandler: getAsyncErrorResultHandler,
        getAsyncReturnedResultHandler: getAsyncReturnedResultHandler,
        getOperands: getOperands,
    },
};
